import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "message message-expired" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Aucun abonnement actif.")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, " L'accès à la pointeuse a été bloqué automatiquement jusqu'au renouvellement de l'abonnement. ")
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "row"
}
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = { class: "message message-expired" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Acces bloqué")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, " L’accès à la pointeuse a été bloqué automatiquement jusqu’au paiement. ", -1)

import { computed } from 'vue'
import type { SubscriptionMember } from "@/interfaces/subscriptionMember"


export default /*#__PURE__*/_defineComponent({
  __name: 'accesBlocked',
  props: {
    subscription: {}
  },
  setup(__props: any) {

const props = __props

const graceDays = computed(() => {
    return props.subscription?.subscription?.grace_days ?? 0
})

return (_ctx: any,_cache: any) => {
  return (!_ctx.subscription)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_ctx.subscription?.is_blocked)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("p", null, [
                _createTextVNode(" Adhérent n’a pas réglé son abonnement et a dépassé le délai de grâce de "),
                _createElementVNode("strong", null, _toDisplayString(graceDays.value) + " jours", 1),
                _createTextVNode(". ")
              ]),
              _hoisted_8
            ])
          ])
        ]))
      : _createCommentVNode("", true)
}
}

})